module.exports = __webpack_public_path__ + "static/media/VWHead-Light.5b54c9ed.woff";